import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { Button } from "framework/components/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { commonUXTheme } from "styles/commonUXVariables";

const FullWidthButton = styled(Button)`
   width: 100%;
`;

interface FooterNavigationButtonsProps {
    step: number,
    onNextClick: () => void;
    onPrevClick?: () => void;
}

export const FooterNavigationButtons = ({ step, onNextClick, onPrevClick }: FooterNavigationButtonsProps): JSX.Element => {
    const { t } = useTranslation();
    const nextBtnText = step == 0 ? t("Start discover") : t("Next");

    const exploreContent = <>
        <FullWidthButton text={t("Explore by functionality")} buttonType={"secondary"}  />
        <p>
            Do you have ANSI code / certain functionality? Visit our product Explorer to
            further evaluate the product's functionality or specific characteristics
        </p>
    </>;

    const compareContent = <>
        <FullWidthButton text={t("Compare products")} buttonType={"secondary"}  />
        <p>
            Visit our product Comparison to compare product's functionality or specific characteristics
        </p>
    </>;

    return <Grid container   >
        <Grid item xs={6} >
            {step != 0 && <Button onClick={onPrevClick} text={t("Previous")} buttonType={"secondary"}  />}
        </Grid>
        <Grid item xs={6} >
            <Stack direction="row" justifyContent="end">
                {step !== 5 && <Button onClick={onNextClick} text={nextBtnText} buttonType={"primary-black"}  />}
            </Stack>
            {step === 5 &&
                <>
                    <Grid padding={commonUXTheme.sizes.xs} container marginY={commonUXTheme.sizes.m}>
                        <h4>{t("Next steps")}</h4>
                    </Grid>
                    <Grid padding={commonUXTheme.sizes.xs} container gap={3}>
                        <Grid item xs={6}  >
                            <FullWidthButton onClick={onNextClick} text={t("Configure and buy")} buttonType={"primary"}  />
                        </Grid>
                        <Grid item xs  >
                            <FullWidthButton onClick={onNextClick} text={t("Connect with us")} buttonType={"secondary"}  />
                            <p>{t("Connect with us for personalized support regarding your sfdjs hfjdshfa ehuerheauhuf safhdufhdsuaf dhufhdfsajhfdf")}</p>
                        </Grid>
                        <Grid item xs={6} >
                            {exploreContent}
                        </Grid>
                        <Grid item xs >
                            {compareContent}
                        </Grid>
                    </Grid>
                </>}
        </Grid>
        {step !== 5 &&
            <Grid marginY={commonUXTheme.sizes.xs} container spacing={2}>
                <Grid item xs={12} md={4}>
                    <FullWidthButton text={t("Configure and buy")} buttonType={"secondary"} />
                    <p>Do you know exactly what you want? Visit out product Configurator</p>
                </Grid>
                <Grid item md={4} xs={12} >
                    {exploreContent}
                </Grid>
                <Grid item md={4} xs={12} >
                    {compareContent}
                </Grid>
            </Grid>
        }
    </Grid>
}
